export default "__VITE_ASSET__Dsh15d9I__"